import Tripadvisor from '../static/icons/tripadvisor.svg';
import GoogleMaps from '../static/icons/google-maps.svg';
import Instagram from '../static/icons/instagram.svg';

export const Icons = {
    tripadvisor: Tripadvisor,
    googleMaps: GoogleMaps,
    instagram: Instagram,
};
